import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../Field'
import {
  FlatSelect,
  getFlatSelectFormikFieldControlDisabledProps,
} from '../../../../Flat'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { useInitiallyOpenSelect } from '../../../../Select'
import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS,
} from '../../RequestEditApplicantAddressModal.constants'

function RequestEditApplicantAddressModalFlatField({
  autoFocus,
  flatApiParams,
  flatDisabled,
  required,
}) {
  const { t } = useTranslation()

  const selectStatesRef = useInitiallyOpenSelect(autoFocus)

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={FlatSelect}
      apiParams={flatApiParams}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t(
              REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS[
                REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT
              ]
            ),
          },
        },
      }}
      disabled={flatDisabled}
      emptyValue={null}
      fieldComponentProps={{
        label: t(
          REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS[
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT
          ]
        ),
        required,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getFieldDisabledProps={getFlatSelectFormikFieldControlDisabledProps}
      name={REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT}
      selectStatesRef={selectStatesRef}
    />
  )
}

export default RequestEditApplicantAddressModalFlatField
